var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWeatherSunny = function SvgWeatherSunny(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentcolor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.76 5.29 4.96 3.5 3.55 4.91 5.34 6.7zM4 10.95H1v2h3zM13 1h-2v2.95h2zm7.45 3.91L19.04 3.5l-1.79 1.79 1.41 1.41zm-3.21 13.7 1.79 1.8L20.44 19l-1.8-1.79zM20 10.95v2h3v-2zm-8-5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6M11 22.9h2v-2.95h-2zm-7.45-3.91 1.41 1.41 1.79-1.8-1.41-1.41z"
  })));
};
export default SvgWeatherSunny;